import * as React from 'react';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';

export default function DatePickerSelf(props) {
    const [value, setValue] = React.useState(null);

    const onChange = props.onChange;
    const name = props.name;

    // Jab props.value change ho, to internal value update karo
    React.useEffect(() => {
        if (props.value) {
            setValue(dayjs(props.value)); // props.value should be in 'YYYY-MM-DD' format or valid date
        }
    }, [props.value]);

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
                value={value}
                onChange={(newValue) => {
                    setValue(newValue);
                    if (onChange) {
                        onChange({ [name]: dayjs(newValue.$d).format('YYYY-MM-DD') });
                    }
                }}
                slotProps={{
                    textField: {
                        size: 'small',
                        fullWidth: true
                    }
                }}
            />
        </LocalizationProvider>
    );
}
